enum Rating {
  excellent = 'A',
  veryGood = 'AB',
  good = 'B',
  ok = 'C',
}
export default Rating;
